<template>
  <div>
    <v-autocomplete
      ref="select"
      :items="enhancedAvailableClients"
      v-model="proxyValue"
      item-text="title"
      item-value="id"
      no-data-text="No clients"
      label="Please, select clients"
      multiple
      small-chips
      deletable-chips
      clearable
      @keyup.enter="handleEnterKeyup"
    >
      <template
        slot="selection"
        slot-scope="props"
      >
        <v-chip
          close
          class="chip--select-multi v-chip--small"
          @input="removeClient(props.item.id)"
        >
          <v-tooltip bottom>
            <span slot="activator">{{ props.item.shortTitle | NoEmpty}}</span>
            <span>{{ props.item.title | NoEmpty}}</span>
          </v-tooltip>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import NoEmpty from '../../Filters/NoEmpty'

export default {
  name: 'clients-select',
  props: {
    value: {
      type: Array
    }
    // todo(TECH-325): add exclude prop
  },
  filters: {
    NoEmpty
  },
  data() {
    return {}
  },
  mounted() {
    this.fetchInitDataIfRequired()
  },
  computed: {
    ...mapState({
      availableClients: 'availableClients'
    }),
    proxyValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    enhancedAvailableClients() {
      return _.map(this.availableClients, client => {
        return {
          ...client,
          shortTitle: _.truncate(client.title, {
            length: 15
          })
        }
      })
    }
  },
  methods: {
    ...mapActions({
      fetchInitDataIfRequired: 'fetchInitDataIfRequired'
    }),
    removeClient(clientId) {
      const removeIndex = this.value.indexOf(clientId)
      let newValue = _.filter(this.value, (item, index) => index !== removeIndex)
      this.$emit('input', newValue)
    },
    handleEnterKeyup() {
      let filteredItems = this.$refs.select.computedItems.map(it => it.id)
      const newValue = _.union(this.value, filteredItems)
      this.$emit('input', newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ClientsSelect.vue